import React, { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import Swal from "sweetalert2";
import "react-phone-number-input/style.css"; // Importa los estilos de react-phone-number-input
import "moment/locale/es";
import moment from "moment";
import axiosClient from "../../../config/axios.js";
import OrderVialVehiclesForm from "./formOrderVial/orderVialVehiclesForm.js";
import { Panel, PanelHeader, PanelBody } from "../../../components/panel/panel";
import InfringementData from "./formOrderVial/InfringementData.js";
import ServiceDetails from "./formOrderVial/serviceDetails.js";
import VehicleEquipmentDetails from "./formOrderVial/vehicleEquipmentDetails.js";
import { FieldArray } from "formik";
import OrderAmountsFieldArrayAdicional from "../orders/orderAmounts/orderAmountsFieldArrayAdicional.js";
import CraneData from "./formOrderVial/craneData.js";
import PaymentData from "./formOrderVial/paymentData.js";

import {
  orderValidationSchema,
  orderInitialValues,
} from "./orderVialFieldsYupValidation";

import { Col } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext.js";

function NewOrderVial() {
  const [operadores, setOperadores] = useState([]);
  const navigate = useNavigate();
  const { Formik } = formik;
  const { token, userId, fullName, username, roles, isAdmin, isAccountant } =
    useAuth();

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/orders-vial">Varo Express</Link>
            </li>
            <li className="breadcrumb-item active">Nueva orden</li>
          </ol>
          <h1 className="page-header mb-0">
            Registro de nueva orden - Varo Express
          </h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Formik
            validationSchema={orderValidationSchema}
            initialValues={orderInitialValues}
            validateOnChange
            onSubmit={(values, { setSubmitting }) => {
              console.log("Formik onSubmit ejecutado");

              setSubmitting(true);
              const formData = new FormData();
              formData.append("photo", values.photo);

              const costosAdicionales = values.montosExtras.reduce(
                (acc, item) => {
                  const monto = parseFloat(item.monto_extra_monto);
                  return acc + (isNaN(monto) ? 0 : monto);
                },
                0
              );

              const total =
                parseFloat(values.subtotal || 0) + costosAdicionales;

              const formattedValues = {
                ...values,
                crane_id: values.crane_id?.value || null,
                operator_id: values.operator_id?.value || null,
                chofer_auxiliar_id: values.chofer_auxiliar_id.value || null,
                vehicles: values.vehiculos.map((vehiculo) => ({
                  ...vehiculo,
                  vehicle_type_id: vehiculo.vehicle_type_id?.value || null,
                  brand_id: vehiculo.brand_id?.value || null,
                  vehicle_model_id: vehiculo.vehicle_model_id?.value || null,
                  color_id: vehiculo.color_id?.value || null,
                  shielding_type_id: vehiculo.shielding_type_id?.value || null,
                  anio: vehiculo.anio?.value || null,
                })),
                vehiculoNumero: values.vehiculos[0]?.vehiculoNumero
                  ? parseInt(values.vehiculos[0].vehiculoNumero, 10)
                  : null,
                costosAdicionales: parseFloat(costosAdicionales.toFixed(2)),
                total: parseFloat(total.toFixed(2)),
                subtotal: 0,
                grua: true,
              };

              console.log("Valores del formulario a enviar:", formattedValues);

              axiosClient
                .post("/order-vial/save", formattedValues)
                .then((response) => {
                  Swal.fire({
                    title: "Registro exitoso.",
                    text: `Se ha registrado la nueva Orden Vial con folio ${String(
                      response.data.folio
                    ).padStart(5, "0")}`,
                    icon: "success",
                    confirmButtonText: "Cerrar",
                    cancelButtonText: "Cancelar",
                    showCancelButton: false,
                  });
                  navigate("/orders-vial");
                })
                .catch((err) => {
                  const errorMessage =
                    err.response?.data?.error ||
                    "Ha ocurrido un error inesperado";

                  Swal.fire({
                    title: "Ups!",
                    text: errorMessage,
                    icon: "error",
                    confirmButtonText: "Cerrar",
                    cancelButtonText: "Cancelar",
                    showCancelButton: false,
                  });

                  setSubmitting(false);
                });
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              validateForm,
              values,
              touched,
              errors,
              setFieldValue,
              setFieldTouched,
              isSubmitting,
              setSubmitting,
            }) => {
              //console.log("montosExtras:", values.montosExtras);

              return (
                <Form
                  noValidate
                  onSubmit={handleSubmit}
                  encType="multipart/form-data"
                >
                  <Row className="mb-3">
                    <Col md="12">
                      <Panel>
                        <PanelHeader noButton={true}>
                          Datos de la orden
                        </PanelHeader>
                        <PanelBody>
                          <InfringementData
                            values={values}
                            setFieldValue={setFieldValue}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                          />
                        </PanelBody>
                      </Panel>

                      <Panel>
                        <PanelHeader noButton={true}>
                          Datos del vehículo
                        </PanelHeader>
                        <PanelBody>
                          <OrderVialVehiclesForm
                            token={token}
                            values={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            touched={touched}
                            errors={errors}
                          />
                        </PanelBody>
                      </Panel>

                      <Panel>
                        <PanelHeader noButton={true}>
                          Datos del servicio
                        </PanelHeader>
                        <PanelBody>
                          <ServiceDetails
                            values={values}
                            setFieldValue={setFieldValue}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                          />
                        </PanelBody>
                      </Panel>

                      <Panel>
                        <PanelHeader noButton={true}>
                          Detalles del equipamiento
                        </PanelHeader>
                        <PanelBody>
                          <VehicleEquipmentDetails
                            values={values}
                            setFieldValue={setFieldValue}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                          />
                        </PanelBody>
                      </Panel>

                      <Panel>
                        <PanelHeader noButton={true}>
                          Datos de operación
                        </PanelHeader>
                        <PanelBody>
                          <CraneData
                            values={values}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                          />
                        </PanelBody>
                      </Panel>

                      <Panel>
                        <PanelHeader noButton={true}>Datos de total a pagar</PanelHeader>
                        <PanelBody>
                          <PaymentData
                            values={values}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                          />
                        </PanelBody>
                      </Panel>

                      <div className="d-flex justify-content-end mt-4">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Guardando..." : "Guardar cambios"}
                        </button>
                        <RouterLink to="/orders-vial" className="btn btn-info">
                          Regresar
                        </RouterLink>
                      </div>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default NewOrderVial;
